import { render } from "./ts_bs.vue?vue&type=template&id=5cd75276"
import script from "./ts_bs.vue?vue&type=script&lang=js"
export * from "./ts_bs.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__